import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { Shield, Sparkles, Zap, Headset } from "lucide-react";

const ICON_MAP = { shield: Shield, sparkles: Sparkles, zap: Zap, headset: Headset };

const WhyUs = () => {
  const { t } = useLanguage();
  return (
    <section
      id="about"
      data-testid="why-section"
      className="py-24 sm:py-32 px-5 sm:px-8 bg-white"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
        <div className="md:col-span-5 md:sticky md:top-32">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-10 h-px bg-brand" />
            <span className="text-[11px] tracking-[0.25em] font-bold text-brand">
              {t.why.eyebrow}
            </span>
          </div>
          <h2
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-brand-ink leading-tight mb-6"
            data-testid="why-title"
          >
            {t.why.title}
          </h2>
          <p className="text-lg text-brand-muted leading-relaxed">
            {t.why.body}
          </p>
        </div>

        <div className="md:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          {t.why.pillars.map((p, i) => {
            const Icon = ICON_MAP[p.icon] || Shield;
            return (
              <div
                key={i}
                data-testid={`why-pillar-${i}`}
                className="group rounded-3xl bg-brand-surface p-8 border border-brand-line/50 hover:border-brand/30 hover:bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
              >
                <div className="w-12 h-12 rounded-xl bg-white border border-brand-line flex items-center justify-center mb-6 group-hover:bg-brand group-hover:border-brand transition-all duration-300">
                  <Icon
                    size={20}
                    strokeWidth={1.5}
                    className="text-brand group-hover:text-white transition-colors duration-300"
                  />
                </div>
                <h3 className="font-display text-2xl font-medium text-brand-ink tracking-tight mb-2">
                  {p.label}
                </h3>
                <p className="text-sm text-brand-muted leading-relaxed">
                  {p.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
